import { useState, useRef, useEffect, useCallback } from "react";

import SingleEvent from "./SingleEvent";
import { Label } from "expano-components";

const statuses = {
  to_do: {
    label: "Do zrobienia",
    status_color: "info",
  },
  in_progress: {
    label: "W trakcie",
    status_color: "warning",
  },
  done: {
    label: "Zakończone",
    status_color: "success",
  },
};

const Events = ({
  available_events,
  id,
  type,
  refetch,
  status,
  available_workflow,
  refetchStatuses,
  is_mass_event_enabled,
  mass_events,
  setMassEvents,
}) => {
  const ref = useRef();
  const [is_open, setOpen] = useState(false);
  const workflow = available_events?.[available_workflow];

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSetMassEvent = useCallback(
    ({ checked, uniq_id, id, type, event }) => {
      if (checked) {
        const _mass_events = [
          ...mass_events,
          {
            action: "trigger_event",
            uniq_id,
            id,
            type,
            event,
          },
        ];
        setMassEvents(_mass_events);
      } else {
        const _mass_events = [...mass_events].filter(
          (item) => item.uniq_id !== uniq_id,
        );
        setMassEvents(_mass_events);
      }
    },
    [mass_events, setMassEvents],
  );

  if (!workflow) {
    return <Label type="fill" text="Zablokowane" color="#a2a5b9" />;
  }

  return (
    <div className="single-box">
      {is_mass_event_enabled ? (
        <div onClick={(e) => e.stopPropagation()}>
          {workflow
            .filter((item) => !item.name.includes("reject_"))
            .map(({ label, name }) => {
              const uniq_id = [type.toLowerCase(), id, name].join("_");
              const is_checked =
                mass_events.findIndex((a) => a.uniq_id === uniq_id) > -1;
              return (
                <div
                  key={uniq_id}
                  className={`event-check ${statuses[status]?.status_color}  ${is_checked ? "active" : ""}`}
                >
                  <input
                    type="checkbox"
                    id={uniq_id}
                    onChange={({ target: { checked } }) =>
                      handleSetMassEvent({
                        checked,
                        uniq_id,
                        id,
                        type,
                        event: name,
                      })
                    }
                    checked={is_checked}
                  />
                  <label htmlFor={uniq_id}>{label}</label>
                </div>
              );
            })}
        </div>
      ) : (
        <div
          className={`event-select ${statuses[status]?.status_color} ${
            is_open ? "open" : ""
          }`}
          ref={ref}
        >
          <button
            className="event-select__trigger"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpen(!is_open);
            }}
          >
            <span className="status-box">{statuses[status]?.label}</span>
            <svg
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="none"
                d="M9 1L5 5L1 1"
                stroke="#192027"
                strokeLinecap="round"
                strokeWidth="2"
              />
            </svg>
          </button>
          <ul className="event-select__options">
            {workflow.map(({ name: event, label, icon }) => (
              <li key={`${type}_${id}_${event}`}>
                <SingleEvent
                  {...{
                    event,
                    label,
                    icon,
                    id,
                    type,
                    refetch,
                    handleClose: () => setOpen(false),
                    refetchStatuses,
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Events;
